import Phaser from 'phaser';
import AScene from './AScene.js';
import AImage from './AImage.js';

export default class AContainer extends Phaser.GameObjects.Container
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, x=0, y=0)
    {
        super(scene, x, y);
        this.scene = scene;
        this._tint = 0xffffff;

        this.events = {};
    }

    /**
     * @return {Phaser.GameObjects.Image}
     */
    create(x, y, key, atlas = this.scene.defaultAtlas)
    {
        let sprite = this.scene.add.existing(new AImage(this.scene, x, y, atlas, key));
        this.add(sprite);
        return sprite;
    }

    addEvent(eventName, method)
    {
        this.events[method]
        if(this.events[eventName] == null) this.events[eventName] = [];
        this.events[eventName].push(method);
    }

    removeEvent(eventName, method)
    {
        if(this.events[eventName] == null) return;
        this.events[eventName].splice(this.events[eventName].indexOf(method), 1);
    }

    removeAllEvents()
    {
        this.events = {};
    }

    invokeEvent(eventName)
    {
        if(this.events[eventName] == null) return;
        for(let i = 0; i < this.events[eventName].length; i++) if(this.events[eventName][i]) this.events[eventName][i]();
    }

    setTint(value)
    {
        this.tint = value;
        return this;
    }

    set tint(value)
    {
        this._tint = value;
        this.list.forEach((child)=>{child.tint = value;});
    }

    get tint()
    {
        return this._tint;
    }
}